/*ng imports*/
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
/*3rd party*/
import { NgIdleModule } from '@ng-idle/core';
import { ChartsModule } from '@rinminase/ng-charts';
import { ToastrModule, ToastrManager } from 'ng6-toastr-notifications';

/*components*/
import { AppComponent } from './app.component';
import { LoadingIndicatorInterceptor } from './LoadingIndicatorInterceptor';

import { AdminComponent } from './admin/admin.component';
import { UserListComponent } from './admin/userList/userList.component';
import { CreateUserComponent } from './admin/create-user/create-user.component';
//import { UserInfoComponent } from './admin/user-info/user-info.component';
import { SourceComponent } from './admin/source/source.component';

import { LoginComponent } from './auth/login/login.component';
import { PasswordResetResultComponent } from './auth/password-reset-result/password-reset-result.component';
import { ResetTokenComponent } from './auth/reset-token/reset-token.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { PasswordResetComponent } from './auth/password-reset/password-reset.component';


import { TestManagerComponent } from './test-manager/test-manager.component';
import { NewrequestComponent } from './requestform/newrequest/newrequest.component';
import { NeedsKitModal } from './requestform/newrequest/needskit.modal';
import { NeedsVenousModal } from './requestform/newrequest/needsvenous.modal';
import { LoadingIndicatorComponent } from './loading-indicator/loading-indicator.component';
import { AcceptComponent } from './accept/accept.component';

import { RequestListFilterComponent } from './requestform/request-list-filter/request-list-filter.component';
import { RequestsListComponent } from './requestform/requests-list/requests-list.component';
import { RequestDetailsComponent } from './requestform/request-details/request-details.component';

import { ResultListFilterComponent } from './results/result-list-filter/result-list-filter.component';
import { ResultListComponent } from './results/result-list/result-list.component';
import { ResultDetailsComponent } from './results/result-details/result-details.component';
import { CumulativeComponent } from './results/result-cumulative/result-cumulative.component';
/*serverices*/
import { HelperService } from './services/helper.service';
import { UserService } from './services/userService';
import { AuthService } from './services/auth.service';
import { TestService } from './services/test.service';
import { TestRequestService } from './services/test-request.service';
import { TestResultService } from './services/test-result.service';
import { SourceService } from './services/source.service';
import { LoadingIndicatorService } from './services/loading-indicator.service';
/*pipes*/
import { SanitizerPipe } from './pipes/Sanitise';


export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    UserListComponent,
    CreateUserComponent,
    CumulativeComponent,
    TestManagerComponent,
    SourceComponent,
    LoginComponent,
    NewrequestComponent,
    //UserInfoComponent,
    LoadingIndicatorComponent,
    RequestListFilterComponent,
    RequestsListComponent,
    RequestDetailsComponent,
    ChangePasswordComponent,
    PasswordResetComponent,
    ResultListFilterComponent,
    ResultListComponent,
    ResultDetailsComponent,
    PasswordResetResultComponent,
    AcceptComponent,
    ResetTokenComponent,
    NeedsKitModal,
    NeedsVenousModal,
    SanitizerPipe
  ],
  imports: [
    ChartsModule,
    BrowserModule,
    HttpClientModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    NgIdleModule.forRoot(),
    RouterModule.forRoot(
      [
        {
          path: 'Admin', component: AdminComponent,
          children: [
            { path: 'users', component: UserListComponent },
            { path: 'createUser', component: CreateUserComponent },
            { path: 'editUser', component: CreateUserComponent },
          ]
        },
        {
          path: 'manage', component: TestManagerComponent,
          children: [
            { path: 'request', component: NewrequestComponent },
            { path: 'result-list', component: ResultListComponent },
            { path: 'result-details', component: ResultDetailsComponent },
            { path: 'request-list', component: RequestsListComponent },
            { path: 'request-details', component: RequestDetailsComponent },
            { path: 'change-password', component: ChangePasswordComponent },
            { path: 'cumul', component: CumulativeComponent }
          ]
        },
        {
          path: '', redirectTo: 'manage', pathMatch: 'full'
        },
        {
          path: 'login', component: LoginComponent
        },
        {
          path: 'accept', component: AcceptComponent
        },
        {
          path: 'password-reset', component: PasswordResetComponent
        },
        {
          path: 'password-reset-result', component: PasswordResetResultComponent
        },
        {
          path: 'reset', component: ResetTokenComponent
        },
        {
          path: 'Source', component: SourceComponent
        }


      ]
    )
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    UserService,
    HelperService,
    TestService,
    SourceService,
    AuthService,
    TestRequestService,
    TestResultService,
    LoadingIndicatorService,
    {
      provide: HTTP_INTERCEPTORS,
      useFactory: (service: LoadingIndicatorService) => new LoadingIndicatorInterceptor(service),
      multi: true,
      deps: [LoadingIndicatorService]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
